import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { crudParam } from '../resolvers/crud.resolver';

export function crudGuard(
  parameterName: string,
  canCreate = true,
  canUpdate = true
): CanActivateFn {
  return route => {
    const value = crudParam(route.paramMap, parameterName);
    if (value === 'new') {
      if (canCreate) return true;
    } else if (value !== undefined && canUpdate) {
      return true;
    }
    return inject(Router).navigate(['/', 'not-found']);
  };
}
